export enum PlatformType {
  APP_STORE = 'app-store',
  GOOGLE_PLAY = 'google-play',
}

export interface IDownloadAppButtonProps {
  type: PlatformType;
  link: string;
}
